export const SettingIcons = ({ type, size = 20, color }) => {
  const icons = {
    general: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.33301 6.66536V4.9987C3.33301 4.55667 3.5086 4.13275 3.82116 3.82019C4.13372 3.50763 4.55765 3.33203 4.99967 3.33203H6.66634M3.33301 13.332V14.9987C3.33301 15.4407 3.5086 15.8646 3.82116 16.1772C4.13372 16.4898 4.55765 16.6654 4.99967 16.6654H6.66634M13.333 3.33203H14.9997C15.4417 3.33203 15.8656 3.50763 16.1782 3.82019C16.4907 4.13275 16.6663 4.55667 16.6663 4.9987V6.66536M13.333 16.6654H14.9997C15.4417 16.6654 15.8656 16.4898 16.1782 16.1772C16.4907 15.8646 16.6663 15.4407 16.6663 14.9987V13.332M6.66634 13.332C6.66634 12.89 6.84194 12.4661 7.1545 12.1535C7.46706 11.841 7.89098 11.6654 8.33301 11.6654H11.6663C12.1084 11.6654 12.5323 11.841 12.8449 12.1535C13.1574 12.4661 13.333 12.89 13.333 13.332M8.33301 7.4987C8.33301 7.94072 8.5086 8.36465 8.82116 8.67721C9.13372 8.98977 9.55765 9.16536 9.99967 9.16536C10.4417 9.16536 10.8656 8.98977 11.1782 8.67721C11.4907 8.36465 11.6663 7.94072 11.6663 7.4987C11.6663 7.05667 11.4907 6.63275 11.1782 6.32019C10.8656 6.00763 10.4417 5.83203 9.99967 5.83203C9.55765 5.83203 9.13372 6.00763 8.82116 6.32019C8.5086 6.63275 8.33301 7.05667 8.33301 7.4987Z"
          stroke="url(#paint0_linear_3650_57173)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3650_57173"
            x1="2.4701"
            y1="14.4594"
            x2="18.0079"
            y2="14.7456"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
        </defs>
      </svg>
    ),
    security: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.0002 10C9.77915 10 9.56719 9.9122 9.41091 9.75592C9.25463 9.59964 9.16683 9.38768 9.16683 9.16667C9.16683 8.94565 9.25463 8.73369 9.41091 8.57741C9.56719 8.42113 9.77915 8.33333 10.0002 8.33333C10.2212 8.33333 10.4331 8.42113 10.5894 8.57741C10.7457 8.73369 10.8335 8.94565 10.8335 9.16667C10.8335 9.38768 10.7457 9.59964 10.5894 9.75592C10.4331 9.9122 10.2212 10 10.0002 10ZM10.0002 10V12.0833M10 2.5C11.9466 4.22215 14.4871 5.11881 17.0834 5C17.4614 6.28585 17.577 7.63456 17.4235 8.96598C17.2699 10.2974 16.8503 11.5844 16.1895 12.7504C15.5288 13.9165 14.6404 14.9378 13.5771 15.7537C12.5138 16.5696 11.2973 17.1635 10 17.5C8.7027 17.1635 7.48626 16.5696 6.42298 15.7537C5.3597 14.9378 4.47128 13.9165 3.81052 12.7504C3.14976 11.5844 2.73014 10.2974 2.57659 8.96598C2.42304 7.63456 2.5387 6.28585 2.91669 5C5.51296 5.11881 8.0535 4.22215 10 2.5Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    notifications: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.49967 14.1667V15C7.49967 15.663 7.76307 16.2989 8.23191 16.7678C8.70075 17.2366 9.33663 17.5 9.99967 17.5C10.6627 17.5 11.2986 17.2366 11.7674 16.7678C12.2363 16.2989 12.4997 15.663 12.4997 15V14.1667M8.33301 4.16667C8.33301 3.72464 8.5086 3.30072 8.82116 2.98816C9.13372 2.67559 9.55765 2.5 9.99967 2.5C10.4417 2.5 10.8656 2.67559 11.1782 2.98816C11.4907 3.30072 11.6663 3.72464 11.6663 4.16667C12.6233 4.61919 13.4392 5.32361 14.0264 6.20442C14.6136 7.08523 14.95 8.10923 14.9997 9.16667V11.6667C15.0624 12.1848 15.2459 12.6809 15.5354 13.1151C15.8248 13.5493 16.2122 13.9095 16.6663 14.1667H3.33301C3.78712 13.9095 4.17452 13.5493 4.464 13.1151C4.75348 12.6809 4.93696 12.1848 4.99967 11.6667V9.16667C5.04931 8.10923 5.38576 7.08523 5.97297 6.20442C6.56017 5.32361 7.376 4.61919 8.33301 4.16667Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    billing: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M11.667 6.66667H9.58366C9.25214 6.66667 8.9342 6.79836 8.69978 7.03278C8.46536 7.2672 8.33366 7.58515 8.33366 7.91667C8.33366 8.24819 8.46536 8.56613 8.69978 8.80055C8.9342 9.03497 9.25214 9.16667 9.58366 9.16667H10.417C10.7485 9.16667 11.0665 9.29836 11.3009 9.53278C11.5353 9.7672 11.667 10.0851 11.667 10.4167C11.667 10.7482 11.5353 11.0661 11.3009 11.3006C11.0665 11.535 10.7485 11.6667 10.417 11.6667H8.33366M10.0003 11.6667V12.9167M10.0003 5.41667V6.66667M4.16699 17.5V4.16667C4.16699 3.72464 4.34259 3.30072 4.65515 2.98816C4.96771 2.67559 5.39163 2.5 5.83366 2.5H14.167C14.609 2.5 15.0329 2.67559 15.3455 2.98816C15.6581 3.30072 15.8337 3.72464 15.8337 4.16667V17.5L13.3337 15.8333L11.667 17.5L10.0003 15.8333L8.33366 17.5L6.66699 15.8333L4.16699 17.5Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    logs: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_5981_15491)">
          <path
            d="M11.6667 2.5V5.83333C11.6667 6.05435 11.7545 6.26631 11.9108 6.42259C12.067 6.57887 12.279 6.66667 12.5 6.66667H15.8334"
            stroke="url(#paint0_linear_5981_15491)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.1667 17.5H5.83335C5.39133 17.5 4.9674 17.3244 4.65484 17.0118C4.34228 16.6993 4.16669 16.2754 4.16669 15.8333V4.16667C4.16669 3.72464 4.34228 3.30072 4.65484 2.98816C4.9674 2.67559 5.39133 2.5 5.83335 2.5H11.6667L15.8334 6.66667V15.8333C15.8334 16.2754 15.6578 16.6993 15.3452 17.0118C15.0326 17.3244 14.6087 17.5 14.1667 17.5Z"
            stroke="url(#paint1_linear_5981_15491)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 14.168H12.5"
            stroke="url(#paint2_linear_5981_15491)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 10.832H12.5"
            stroke="url(#paint3_linear_5981_15491)"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_5981_15491"
            x1="11.397"
            y1="5.97729"
            x2="16.2526"
            y2="6.06674"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5981_15491"
            x1="3.41164"
            y1="15.0183"
            x2="17.009"
            y2="15.2131"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5981_15491"
            x1="7.17641"
            y1="15.0025"
            x2="12.956"
            y2="15.5348"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint3_linear_5981_15491"
            x1="7.17641"
            y1="11.6666"
            x2="12.956"
            y2="12.1989"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <clipPath id="clip0_5981_15491">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  };

  return icons[type];
};

export default SettingIcons;
